import React from 'react';
import Helmet from 'react-helmet';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import ShoppingCartStore from '../../stores/ShoppingCartStore';
import InventoryRecordStore from '../../stores/InventoryRecordStore';
import Checkout from '../../components/Checkout';
import styles from './index.sass';

class CheckoutContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps() {
    let { store } = this.props;
    let description = store.metaTagDescription();
    let title = store.metaTagTitle();
    return {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };
  }

  render() {
    let { currentRoute, customer, customerError, customerRequestStatus, store, shoppingCart, shoppingCartError, shoppingCartRequestStatus } = this.props;
    let checkoutProps = { currentRoute, customer, customerError, customerRequestStatus, store, shoppingCart, shoppingCartError, shoppingCartRequestStatus };

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps()} />
        <Checkout {...checkoutProps} />
      </section>
    );
  }
}

CheckoutContainer = connectToStores(CheckoutContainer, [ShoppingCartStore, CustomerStore], (context, props) => {
  let storeId = props.store.id;
  let customerStore = context.getStore(CustomerStore);
  let shoppingCartStore = context.getStore(ShoppingCartStore);
  return {
    customerError             : customerStore.getCurrentError(),
    customerRequestStatus     : customerStore.getCurrentRequestStatus(),
    shoppingCartError         : shoppingCartStore.getErrorByStoreId(storeId),
    shoppingCartRequestStatus : shoppingCartStore.getRequestStatusByStoreId(storeId)
  };
});

export default CheckoutContainer;



// WEBPACK FOOTER //
// banquet/containers/CheckoutContainer/index.js